import {getAuth, signInWithEmailAndPassword} from 'firebase/auth'
import firebase from '../../firebase/FirebaseConfig'
import {Container, Row, Col, Form, Button} from 'react-bootstrap'
import {useState} from 'react'
import {useUser} from './UserContext'
import {Link} from 'react-router-dom'

const firestore = firebase.firestore()

export function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const {user, setUser, setLoginMethod} = useUser() // Access user and setUser from context
  const [loading, setLoading] = useState(false)

  const auth = getAuth()

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user
        firestore
          .collection('users')
          .where('userId', '==', user.uid)
          .get()
          .then((querySnapshot) => {
            let count = querySnapshot.size

            querySnapshot.forEach((doc) => {
              const userInfo = {
                email: doc.data().email,
                firstName: doc.data().firstName,
                lastName: doc.data().lastName,
                userId: doc.data().userId,
                userIdMalin1: doc.data().userIdMalin1,
                role: doc.data().role || 'user',
                imageProfile: doc.data().imageProfile || '',
              }
              setLoginMethod('login')
              setUser(userInfo)
              setLoading(false)
            })

            if (count == 0) {
              setError('This account does not have permission to access this platform.')
            }
          })
          .catch((error) => {
            // Handle login errors
            const errorMessage = error.message
            setError(errorMessage)
          })
        // Update the user data in the context
      })
      .catch((error) => {
        // Handle login errors
        const errorMessage = error.message
        setError(errorMessage)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Container>
      <Row className='d-flex justify-content-center' style={{fontSize: 30, fontWeight: 'bold'}}>
        Sign In
      </Row>

      <Row className='justify-content-center mt-5'>
        <Col md={12}>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId='email' className='mt-5'>
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type='email'
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onInvalid={(e) => e.target.setCustomValidity('Please enter email')}
                required
              />
            </Form.Group>
            <Form.Group controlId='password' className='mt-5'>
              <Form.Label>Password:</Form.Label>
              <Form.Control
                type='password'
                placeholder='Password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onInvalid={(e) => e.target.setCustomValidity('Please enter password')}
                required
              />
            </Form.Group>
            {/* <div className='d-flex justify-content-end'>
              <Link to='/auth/forgot-password' className='link-primary'>
                Reset Password ?
              </Link>
            </div> */}
            <Button
              variant='primary'
              type='submit'
              className='my-10'
              style={{width: '100%'}}
              disabled={loading} // Disable the button while loading
            >
              {loading ? 'Loading...' : 'Login'}
            </Button>
          </Form>
          {error && <p className='text-danger mt-3'>{error}</p>}
          {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
            Not a Member yet?{' '}
            <Link to='/auth/registration' className='link-primary'>
              Sign up
            </Link>
          </div> */}
        </Col>
      </Row>
    </Container>
  )
}
